export default __webpack_public_path__ + "static/media/message-success-circle.41d3e784.svg";